import {
  Activity,
  ArrowLeft,
  ArrowRight,
  ArrowUpDown,
  SquareArrowUpRight,
  SquareArrowDown,
  BarChart3,
  BookOpen,
  BookText,
  Calculator,
  Calendar,
  CalendarArrowDown,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Clock,
  Cloud,
  Compass,
  Copy,
  Cpu,
  Database,
  Eye,
  EyeOff,
  FileText,
  Filter,
  FunnelX,
  Github,
  HardDrive,
  Home,
  Info,
  Key,
  Layers,
  LayoutDashboard,
  Lightbulb,
  Link2,
  List,
  LoaderCircle,
  LogOut,
  MemoryStick,
  Monitor,
  MoreVertical,
  Network,
  Play,
  Plus,
  RefreshCw,
  Router,
  Search,
  Server,
  Settings,
  Shapes,
  SquareArrowOutUpRight,
  Trash2,
  TrendingDown,
  User,
  UserRoundPlus,
  UserRoundCheck,
  X,
} from 'lucide-angular';

export const lucideIcons = {
  Activity,
  ArrowLeft,
  ArrowRight,
  ArrowUpDown,
  SquareArrowUpRight,
  SquareArrowDown,
  BarChart3,
  BookOpen,
  BookText,
  Calculator,
  Calendar,
  CalendarArrowDown,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Clock,
  Cloud,
  Compass,
  Copy,
  Cpu,
  Database,
  Eye,
  EyeOff,
  FileText,
  Filter,
  FunnelX,
  Github,
  HardDrive,
  Home,
  Info,
  Key,
  Layers,
  LayoutDashboard,
  Lightbulb,
  Link2,
  List,
  LoaderCircle,
  LogOut,
  MemoryStick,
  Monitor,
  MoreVertical,
  Network,
  Play,
  Plus,
  RefreshCw,
  Router,
  Search,
  Server,
  Settings,
  Shapes,
  Trash2,
  TrendingDown,
  SquareArrowOutUpRight,
  User,
  UserRoundPlus,
  UserRoundCheck,
  X,
};
